import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-general-health',
  templateUrl: './general-health.component.html',
  styleUrls: ['./general-health.component.css'],
  providers: [SharedService]
})
export class GeneralHealthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
